import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Modal, Typography, Form, Input, Row, Col, message, Select, Upload, Button } from 'antd';
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import { createUser } from 'requests/user';
import BaseSelect from 'components/Elements/BaseSelect';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { parseQueryParams, stringifyQueryParams } from "utils/url";
import { UploadOutlined } from "@ant-design/icons";
import {
	getBills,
	getSubBills,
	deleteBill,
	updateBill,
} from "requests/bill";

const OrderViewCardOrders = (props) => {
	const { visible, onClose, onSubmit } = props;
	const [loading, setLoading] = useState(false);
	const [roles, setRoles] = useState([]);
	const [selectedRole, setSelectedRole] = useState(null);
	const [formRef] = Form.useForm();
	const token = localStorage.getItem('token');
	const { Title } = Typography;
	const [records, setRecords] = useState([]);
	const location = useLocation();

	useEffect(() => {
		const query = parseQueryParams(location);
		getRecords(query);
	}, [location]);

	const getRecords = async (query) => {
		try {
			const updatedQuery = { ...query, status: 'all' };
			const response = await getBills(updatedQuery);
			const { data } = response;
			setRecords(data);
			console.log(data);

		} catch (err) {
			console.error(err);
		}
	};

	const onSubmitData = () => {
		formRef.validateFields().then(async (data) => {
			try {
				setLoading(true);
	
				const selectedCategory = records.find((item) => item._id === data.category_id);
				const formData = new FormData();
	
				formData.append("category_id", data.category_id);
				formData.append("category_name", selectedCategory?.name || '');
				formData.append("name", data.name);
				formData.append("status", data.status);
	
				// Append image binary file
				if (data.image && data.image[0]?.originFileObj) {
					formData.append("image", data.image[0].originFileObj);
				}
	
				await axios.post(
					"https://billpay.mtmpay.in/Admin/api/admin/bill-subcategory-create",
					formData,
					{
						headers: {
							"Authorization": `Bearer ${token}`,
							"Content-Type": "multipart/form-data"
						}
					}
				);
	
				toast.success("Bill Sub Category created successfully!");
				onCancel();
				onSubmit && onSubmit();
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			} catch (err) {
				console.error(err);
				toast.error(err.response?.data?.message || "Failed to create user");
			} finally {
				setLoading(false);
			}
		});
	};
	

	const onCancel = () => {
		formRef.resetFields();
		setRoles([]);
		setSelectedRole(null);
		onClose();
	};

	return (
		<Modal
			title={'Create new bill sub category'}
			open={visible}
			closable={false}
			onCancel={onCancel}
			onOk={onSubmitData}
			okButtonProps={{ loading: loading }}
			okText="Submit"
			width={700}
		>
			<Form layout="vertical" form={formRef} autoComplete="off">
				<Row gutter={[16, 16]}>
					<Col lg={12} md={12} sm={24} xs={24}>
						<Form.Item
							name="category_id"
							label="Select Bill Category"
							rules={[{ required: true, message: 'Please select a category' }]}
						>
							<Select placeholder="Select a category">
								{records.map((category) => (
									<Select.Option key={category._id} value={category._id}>
										{category.name}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>

					<Col lg={12} md={12} sm={24} xs={24}>
						<Form.Item
							name="name"
							label="Subcategory Name"
							rules={[{ required: true, message: 'Please enter a subcategory name' }]}
						>
							<Input placeholder="Enter subcategory name" />
						</Form.Item>
					</Col>

					<Col lg={12} md={12} sm={24} xs={24}>
						<Form.Item
							name="image"
							label="Image"
							valuePropName="fileList"
							getValueFromEvent={(e) => Array.isArray(e) ? e : e && e.fileList}
							rules={[{ required: true, message: 'Please upload an image' }]}
						>
							<Upload
								name="image"
								listType="picture"
								maxCount={1}
								beforeUpload={() => false} 
							>
								<Button icon={<UploadOutlined />}>Click to Upload</Button>
							</Upload>
						</Form.Item>
					</Col>


					<Col lg={12} md={12} sm={24} xs={24}>
						<Form.Item
							name="status"
							label="Status"
							initialValue={1}
							rules={[{ required: true, message: 'Please select a status' }]}
						>
							<Select>
								<Select.Option value={1}>Active</Select.Option>
								<Select.Option value={0}>Inactive</Select.Option>
							</Select>
						</Form.Item>
					</Col>


				</Row>
			</Form>

		</Modal>
	);
	<ToastContainer />
};

OrderViewCardOrders.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired,
};

export default OrderViewCardOrders;
